import { render, staticRenderFns } from "./UserDetailModalCard.vue?vue&type=template&id=2a39e360&"
import script from "./UserDetailModalCard.vue?vue&type=script&lang=js&"
export * from "./UserDetailModalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports